<template>
    <div v-if="isreadshow">
        <action-row>
            <my-btn type="new" @click="zjcq()" v-if="xmlbcode=='102'">专家抽取申请</my-btn>
            <my-btn type="new" @click="addHandler()">组建评标委员会</my-btn>
            <my-btn type="new" @click="allYuChuLiHandler()">评委计算机环境预处理</my-btn>
        </action-row>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="评审时间" prop="pstime" fixed width="260">
            </el-table-column>
            <el-table-column label="包含标段" prop="bdnames" min-width="300"></el-table-column>
            <el-table-column label="操作" width="500" fixed="right">
                <template slot-scope="scope">
                    <template>
                        <template v-if="scope.row.shbj === '1'">
                            <my-btn
                                type="detail"
                                @click="detailHandler(scope.row.zjsqcode)">
                                详情
                            </my-btn>
                        </template>
                        <template v-else>
                            <my-btn
                                type="edit"
                                @click="editHandler(scope.row.zjsqcode)">
                                修改
                            </my-btn>
                            <my-btn
                                type="del"
                                @click="delHandler(scope.row.zjsqcode)">
                                删除
                            </my-btn>
                        </template>
                        </template>
                            <el-button
                                type="text"
                                icon="el-icon-user"
                                @click="chengYuanHandler(scope.row)"  v-if="!baoding ||scope.row.typbzjk!=='1'">
                                成员管理
                            </el-button>
                    
                            <el-button
                                type="text"
                                icon="el-icon-user"
                                @click="yuChuLiHandler(scope.row)">
                                评委计算机环境预处理
                            </el-button>
                </template>
            </el-table-column>
        </my-table>
                   
        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/newpingbiao/pbwyh/get_list.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: { },
    data() { 
        return {
            pgData: {
                sortname: 't.zjsqcode',
                procode: this.getQuery('procode'),
                zgys: this.getQuery('zgys')
            },
            isreadshow:true,                       
            model: {},
            baoding:'',
            xmlbcode:''
        }
    },
    computed: {
        procode() {
            return this.getQuery('procode');
        },      
        zgys(){
            return this.getQuery('zgys');
        } 
    },                                                                                                                              
    methods: {
         //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },                 
        addHandler() {
            this.goto({
                path:'./edit',
                query:{
                    procode:this.pgData.procode,
                    zgys:this.pgData.zgys,
                }
            });  
        },
        zjcq() {
            var src = `/dist/index.html#/agency/zj/zjsq/list?zbprocode=${this.pgData.procode}`;
            window.location=src
        
        },
        chengYuanHandler(row) {
            this.goto({
                path: './cygl/list',
                query: {
                    zjsqcode: row.zjsqcode,
                    procode: this.procode,
                    zgys:this.zgys               
                }
            });    
        }, 
        allYuChuLiHandler() {
            this.goto({
                path: './allyujiazai',
                query: {
                    procode: this.pgData.procode,
                }
            });                      
        },
        yuChuLiHandler(row) {
            this.goto({
                path: './yujiazai',
                query: {
                    zjsqcode: row.zjsqcode,
                }
            });
        },
        detailHandler(id) {
            this.goto({
                path:'./detail',
                query:{
                    procode:this.pgData.procode,
                    zgys:this.pgData.zgys,
                    id:id
                }                    
            });
        },                                                                             
        editHandler(id) {
            this.goto({
                path:'./edit',
                query:{
                    procode:this.pgData.procode,
                    zgys:this.pgData.zgys,
                    id:id
                }
            });                                              
        },                                                 
        delHandler(id) {
            var that=this;         
            that.$post(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/del.json`,{
                id:id,
                oper:'del'
            }, (data, res) => {
                ShowMsg('删除成功', 'success')
                that.reload()
            }); 
        }

    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/list.json`, this.getQuery(), data => {
            this.baoding=data.baoding
            this.xmlbcode=data.xmlbcode
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>